import type { ServiceRequestMessage } from "bonusx-api-main-manager";
import { atomWithStorage } from "jotai/utils";

export interface IServiceRequestMessagesDetail {
  messages: ServiceRequestMessage[];
  totalCount: number;
}

export interface IChatMessageStore {
  [serviceRequestId: number]: IServiceRequestMessagesDetail;
}

const initialState: IChatMessageStore = {};
const CHAT_MESSAGE_STORE_KEY = "chatMessageStorage";

export const ChatMessageStore = atomWithStorage<IChatMessageStore>(CHAT_MESSAGE_STORE_KEY, initialState, undefined, {
  getOnInit: true,
});
